export const APP_INITIALIZE = 'APP_INITIALIZE'